import { Avatar, Tooltip, TooltipProps, Typography } from '@mui/material'
import type { CSSProperties, PropsWithChildren } from 'react'

import { CalfBirthStatus, Gender } from '#/@types/backend'
import Colors from '#/styles/Colors'
import Palette from '#/styles/Palette'

type Enum<T extends string | null> = {
  status: T
  text: string
}

export type Calf = {
  status?: Enum<CalfBirthStatus>
  gender?: Enum<Gender | null>
}

type Props = Pick<TooltipProps, 'children'> & Calf

const CalfTooltip = ({ children, gender, status }: PropsWithChildren<Props>) => (
  <Tooltip
    title={
      <>
        <Typography>{gender?.text}</Typography>
        {status !== undefined && <Typography>{status.text}</Typography>}
      </>
    }
  >
    {children}
  </Tooltip>
)

export const CalfBadge = ({ gender, status }: Calf) => {
  const letter = gender?.text ? (gender.text.substring(0, 1) ?? '-') : '-'

  const styleByGender: Record<Gender | 'unknown', CSSProperties> = {
    female: Colors.sex.female,
    male: Colors.sex.male,
    unknown: {
      ...Colors.sex.unknown,
      border: `1px solid ${Palette.gray.light[500]}`,
    },
  }

  const colorStyle =
    status?.status === 'stillbirth' ? {} : styleByGender[gender?.status ?? 'unknown']

  const style: CSSProperties = {
    fontSize: '0.8rem',
    height: '30px',
    textTransform: 'uppercase',
    width: '30px',
    ...colorStyle,
  }

  return (
    <CalfTooltip status={status} gender={gender}>
      <Avatar style={style}>{letter}</Avatar>
    </CalfTooltip>
  )
}
